import React from "react";
import { Navigate } from "react-router-dom";

export default function PartnersPage() {
  return <Navigate to="/apps" replace />;
}
